module.exports = __webpack_public_path__ + "static/media/bc_arrow_white.1c429e0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bc_arrow_white.svg
// module id = 1025
// module chunks = 3